import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-service-review',
  templateUrl: './service-review.component.html',
  styleUrls: ['./service-review.component.scss']
})
export class ServiceReviewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
